// hardcodedMenus.js — 하드코딩 메뉴 목록 (2026-10-27 미남님 결정)
//   하드코딩 메뉴 = 특정 테넌트 규칙(회사 코드·거래처·금액·부서 이름 등)이 코드에 박혀 있어, 다른 손님에게 그대로 주면
//   제대로 돌지 않는 메뉴. 일부만 박혀 있어도 하드코딩이다("일부든 아니든 하드코딩").
//   운영자 화면(테넌트 관리: 테넌트 메뉴·회사 메뉴·요금제)에서만 연한 붉은색 + 한 줄 설명으로 보인다. 배정은 그대로 가능.
//   ⚠ 실무자·손님 테넌트 관리자 화면에는 쓰지 말 것 — 설명에 다른 테넌트 이름(파인그룹)이 들어 있다.
//   약속: 하드코딩 메뉴를 만들면 여기에 등록하고, 하드코딩을 없애면(설정값으로 바꾸면) 같은 커밋에서 지운다.
//   키 = saas_modules.code. 근거는 2026-10-27 메뉴 38개 점검(docs/structure.md).

export const HARDCODED_MENUS = {
  // 통째로 파인그룹 규칙
  SETTLEMENT: '파인그룹 맞춤 · 정산 계산표가 PINE·DOT·LNJ 3곳만',
  PAYOUT: '파인그룹 맞춤 · 지급 기록이 정산서 관리(3곳)에서만, 이체 보내는 사람 (주)파인그룹',
  CASHFLOW: '파인그룹 맞춤 · DOT 정산서·샘이콜론 매입·홍보물월정산이 고정 항목',
  CASHFLOW_SEMECOLON: '파인그룹 맞춤 · 거래처 샘이콜론 고정',
  PROMOTIONAL_MONTHLY: '파인그룹 맞춤 · 회사 PINE·마곡=DOT·기본료 85만/80만 원 고정',
  QUOTE: '파인그룹 맞춤 · 견적서 공급자(사업자번호·계좌·로고) 고정',
  CONSULTANT_1ON1: '파인그룹 맞춤 · 부서 이름(행사지원·마케팅)으로 사람을 고름',
  EMERGENCY_TEAM: '파인그룹 맞춤 · 본사 화면만 있음, 기본 주 10만 원',
  // 일부만 파인그룹 규칙
  FINANCE_REVENUE: '파인그룹 맞춤(일부) · DOT 전용 표·주소가 따로 있음',
  CASHFLOW_PURCHASE: '파인그룹 맞춤(일부) · 본사 화면만 있음',
  CONTRACT_RENEWAL: '파인그룹 맞춤(일부) · PINE만 행사지원(파트) 자동 등록',
  TM_SCORE: '파인그룹 맞춤(일부) · 본사 점수 화면 PINE 고정(보류 중)',
  SUMMARY: '파인그룹 맞춤(일부) · 장수 배수표 PINE 기준(보류 중)',
  AIRTEL_RESERVATION: '파인그룹 맞춤(일부) · 카드입금 기본 계좌 (주)파인그룹',
  SITUATION_BOARD: '파인그룹 맞춤(일부) · 회사 위젯 숫자가 PINE·DOT·LNJ만',
  AUDIT_LOG: '파인그룹 맞춤(일부) · 정산 기록 회사 고르기가 3곳뿐',
  DYNAMIC_SETTINGS: '파인그룹 맞춤(일부) · 환산장수·정산 설정이 파인그룹 기준',
  WORK_ASSIGNMENT: '파인그룹 맞춤(일부) · "(파인그룹)" 이름표가 남아 있음',
};

// 손님 테넌트에게 아직 줄 수 없는(서버가 손님 회사 범위로 바꾸지 않은) 메뉴의 설명 — 하드코딩 여부와 별개
export const NOT_CONVERTED_NOTE = '손님용 전환 전 — 켜도 손님에게 안 생김(끄기만 됨)';

export function hardcodedNote(code) {
  return HARDCODED_MENUS[String(code || '').toUpperCase()] || '';
}

// 눈이 편한 연한 붉은색 — 밝은·다크 테마 모두(색을 테마 글자색과 섞어 다크에서 저절로 밝아진다)
export const RED_CARD = {
  border: '1px solid rgba(220, 38, 38, 0.28)',
  background: 'rgba(220, 38, 38, 0.05)',
};
export const RED_NOTE = {
  fontSize: 10.5,
  lineHeight: 1.4,
  color: 'color-mix(in srgb, var(--danger) 72%, var(--text-sub))',
};

// 켤 때 확인 창 앞에 붙일 경고 한 줄
export function redConfirmPrefix(code) {
  const note = hardcodedNote(code);
  return note ? `⚠ 하드코딩 메뉴 — ${note}\n다른 손님에게는 그대로 맞지 않을 수 있어요.\n\n` : '';
}
